import React, { Fragment } from 'react';

const NativeAppFeatureList = () => {
  return (
    <Fragment>
      <li>Share your matched photo stream with family and friends.</li>
      <li>Post &amp; download your favorite pics in hi-res.</li>
      <li>Create and send Waldograms featuring your photos.</li>
      <li>Order prints delivered directly to your home.</li>
    </Fragment>
  );
};

export default NativeAppFeatureList;
